import { Link } from "react-router-dom";
import { allCategories, allVideos } from "@/lib/video";

const iconStyles = [
  "bg-primary-100 text-primary-600",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-700",
];

export default function CategoryQuickLinks() {
  return (
    <section className="mt-12">
      <div className="mb-5 text-center">
        <h2 className="text-lg font-semibold text-foreground-950 md:text-2xl">
          按类型发现视频
        </h2>
        <p className="mt-1.5 text-sm text-foreground-500">
          六大内容板块，快速进入你感兴趣的分类
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
        {allCategories.map((cat, index) => {
          const count = allVideos.filter((v) => v.category === cat.slug).length;
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex cursor-pointer flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-3 py-5 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <span
                className={`flex h-12 w-12 items-center justify-center rounded-lg transition-transform duration-300 group-hover:scale-110 ${
                  iconStyles[index % iconStyles.length]
                }`}
              >
                <i className={`${cat.icon} text-2xl`} />
              </span>
              <span className="text-sm font-medium text-foreground-900">{cat.name}</span>
              <span className="text-xs text-foreground-400">{count} 个视频</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}